import { Address } from './pages/types';

export const getAddressLines = (address: Address): string[] => {
  if (!address) return [];
  const { address1, address2, city, state, zip } = address;
  const firstLine = `${address1}${address2 ? ', ' + address2 : ''}`;
  const secondLine = `${city}, ${state.toLocaleUpperCase()} ${zip}`;
  return [firstLine, secondLine];
};
